import React from 'react';
import ToggleButton from 'components/V1/ToggleButton/ToggleButton';
import { useEnvironment } from 'context/EnvironmentContext/EnvironmentContext';
import { Flex } from '@applatform/design-system';

function EnvironmentToggle() {
  const { environment, setEnvironment } = useEnvironment();

  return (
    <Flex css={{ maxWidth: '184px', mx: 'auto', mb: '$8' }}>
      <ToggleButton
        onClick={() => setEnvironment('live')}
        isActive={environment === 'live'}
        disabled={environment === 'live'}
        css={{ flex: '1' }}
      >
        Live
      </ToggleButton>
      <ToggleButton
        onClick={() => setEnvironment('pre-live')}
        isActive={environment === 'pre-live'}
        disabled={environment === 'pre-live'}
        css={{ flex: '1' }}
      >
        Pre-live
      </ToggleButton>
    </Flex>
  );
}

export default EnvironmentToggle;
